import Displiner from '../../../views/Student/displiner/Displiner.student.view';

export default Displiner;
